/// <reference path="Utilities/_reference.ts" />

module YVR.PassengerJourney {
	// Dependencies
	import flights = YVR.Utilities.Flights;
	import logger = YVR.Utilities.Logger;
	import facilities = YVR.Facilities;
	import i18n = YVR.Utilities.I18n;

	// Airline Info Additional Services interface
	interface IAdditionalService {
		AdditionalServiceTitle?: string;
		AdditionalServiceLink?: string;
	}

	//Airline Info interface
	interface IAirline {
		Name?: string;
		Link?: string;
		Phone?: string;
		AdditionalServices?: IAdditionalService[];
	}

	//Airline Collection Interface
	interface IAirlineCollection {
		value: IAirline[];
	}

	//cache flight data
	let flightCache: IFlight[] = [];

	//cache airline info data
	let airlineCache: IAirline[] = [];

	//
	let facilitiesCache: IFacility[] = [];

	//const vars
	const dineFilter = 'STR_FOOD_DRINK';
	const shopFilter = 'STR_SHOPS';
	const serviceFilter = 'LOC_PERSONAL_SERVICES';

	//options for shop and dine cards
	let options;
	options = {
		facilities: {
			serviceUrl: '/' + i18n.getCurrentLanguage() + '/_api/Facilities',
			select: [
				'Description',
				'FacilityId',
				'IsOpenNow',
				'NextOpenOrClosedTime',
				'PoiAccessibility',
				'PoiAccessibilityLongDescription',
				'PoiBuildingLevel',
				'PoiCategory',
				'PoiGate',
				'PoiID',
				'PoiKeywords',
				'PoiLogo',
				'PoiNameLocID',
				'PoiSubCategory',
				'PoiTaglineLocID',
				'PoiTerminal',
				'PoiTerminalLongDescription',
				'PoiYVRLocationDesc',
				'StoreFront_4x3_2x_Url',
				'SubCategoryDescription',
				'PoiOpeningHours'
			]
		}
	};


	// CSS Classes
	const classes = {
		airline: 'airline-info'
	};

	// Cached jQuery elements
	const elements = {
		flightId: $('#yvr-flightid'),
		flightInfo: $('#yvr-flight-details-banner'),
		airlineInfo: $(`.${classes.airline}`)
	};

	//api url
	let odataUrl = elements.airlineInfo.attr('data-odata-url');

	//main function
	function main() {
		if ($('.yvr-passenger-journey').length > 0) {
			//console.log('passenger-journey');
			getFlightInfo();
			eventBindAccordion();
			eventBindSliderTabs();
		}
	}

	//gets flight info
	function getFlightInfo() {
		//console.log('get flight info');
		if (elements.flightInfo.length) {

			let id = elements.flightId.val();

			flights.getFlightByFlightId(id)
				.then(renderFlightDetails)		//displays flight data in banner. Also caches
				.then(getAirlineInfo)			//needs flight info to get airline info
				.then(renderDynamicAccordions)	//render dynamic text
				.then(getShopDineData)			//
				.fail(() => {
					//console.log('[flight-notification][getFlightInfo] An error occured retrieving the flight data.');
					$('#yvr-accordion').hide();
					$('#expired').show();
					redirectToFlightsPage();
				});
		} else {
			$('#yvr-accordion').hide();
			$('#expired').show();
			redirectToFlightsPage();
		}
	}

	function redirectToFlightsPage() {
		setTimeout(function () {
			window.location.replace('./'); }, 5000);
	}


	// renders dynamic accordions
	function renderDynamicAccordions() {
		if (flightCache && flightCache[0]) {
			let thisFlight = flightCache[0];

			//FlightCheckinTime -> 2,3, or 4 hours before flight time depending on terminal
			if (thisFlight['FlightScheduledTime']) {
				let flightDate = new Date(thisFlight['FlightScheduledTime']); //in Vancouver time
				//set opening time for terminals
				let flightRange = thisFlight['FlightRange'];
				let flightRangeFormatted = formatTerminal(flightRange);

				if (flightRangeFormatted === 'International') {
					flightDate.setHours(flightDate.getHours() - 4);
				} else if (flightRangeFormatted === 'Domestic') {
					flightDate.setHours(flightDate.getHours() - 2);
				} else if (flightRangeFormatted === 'US') {
					flightDate.setHours(flightDate.getHours() - 3);
				} else {
					flightDate.setHours(flightDate.getHours() - 2);
				}

				thisFlight['FlightCheckinTime'] = YVR.Utilities.Dates.formatShortTime(flightDate);
			}

			if (thisFlight['FlightEstimatedTime']) {

				let shortTime = YVR.Utilities.Dates.formatShortTime(thisFlight['FlightEstimatedTime']);

				thisFlight['FlightEstimatedTime'] = shortTime;

			}
			if (thisFlight['FlightScheduledTime']) {

				let shortTime = YVR.Utilities.Dates.formatShortTime(thisFlight['FlightScheduledTime']);

				thisFlight['FlightScheduledTime'] = shortTime;

			}

			window['thisFlight'] = thisFlight;

			//Counters for the south terminal
			if (thisFlight['FlightCarrier'] === 'SG') { //Iskwew
				thisFlight['FlightCounterFrom'] = '811';
				thisFlight['FlightCounterTo'] = '812';

				if (thisFlight.FlightGate === '') {
					thisFlight.FlightGate = 'G3/G4';
				}
			} else if (thisFlight['FlightCarrier'] === '8P') { //Pacific Coastal
				thisFlight['FlightCounterFrom'] = '792';
				thisFlight['FlightCounterTo'] = '800';
			} else if (thisFlight['FlightCarrier'] === '9M') { //Central Mountain Air
				thisFlight['FlightCounterFrom'] = '813';
				thisFlight['FlightCounterTo'] = '816';
			} else {
				thisFlight['FlightCounterFrom'] = '801';
				thisFlight['FlightCounterTo'] = '810';
			}

			//tbd flight gate
			if (thisFlight['FlightGate'] == '') {
				thisFlight['FlightGate'] = 'TBD';
			}

			//get terminal, using Sitecore translation from banner
			thisFlight['FlightTerminal'] = $('.terminal-text').text() + ' ' + $('.terminal-heading').text();

			const accordionItems = document.querySelectorAll('.static-accordion');

			accordionItems.forEach(item => {
				for (const key of Object.keys(thisFlight)) {
					let $content = $(item).find('.content');
					let $header = $(item).find('.header-dynamic');

					if ($content != null) {
						$content.html($content.html().replace('[' + key + ']', thisFlight[key]));
					}
					if ($header != null) {
						$header.html($header.html().replace('[' + key + ']', thisFlight[key]));
					}
				}
			});

		} else {
			//hide dynamic elements or add error state or error message
		}
	}

	//uses handlebars to render flight details. FlightDetailsBanner-Template.cshtml is the template used
	function renderFlightDetails(data: IFlightCollection) {
		if (data && data.value && data.value.length) {

			flightCache = data.value;
			//console.log(flightCache);

			//console.log('setting flightData');
			window['flightData'] = data.value;

			//const source = $('#yvr-flight-details-template').html();
			//const template = Handlebars.compile(source);

			let template = null;

			if (document.documentElement.lang === "fr") {
				template = YVR.templates.flightDetailsBannerFR;
			} else {
				template = YVR.templates.flightDetailsBannerEN;
			}

			const html = template({ flights: data.value });

			//console.log(html);
			$('#yvr-flight-details-banner').html(html);

		}
	}

	// this function gets the airline info the for banner at the bottom
	function getAirlineInfo() {

		//console.log('get airline info');

		////console.log(flightCache);

		let airline = flightCache[0]['FlightAirlineName'];
		let carrier = flightCache[0]['FlightCarrier'];

		odataUrl += airline + '&carrier=' + carrier;
		////console.log(odataUrl);

		callAirlineApi()
			.then(renderAirlineInfo)
			.fail(() => {
				logger.error('error occured getting airline data.');
				//console.log('failed to get data');
			});
	}

	// calls API for airline info. API is on Fishtank side
	function callAirlineApi(): JQueryPromise<IAirlineCollection> {
		return $.get({
			url: odataUrl,
			success() {
				logger.log('Successfully retrieved airline info data.');
			}
		});

	}

	//uses handlebars to render. AirlineInfo-Template.cshtml is the template used.
	function renderAirlineInfo(data: IAirlineCollection) {
		if (data && data.value && data.value.length) {
			////console.log(data);
			////console.log(data.value);

			airlineCache = data.value;
			//console.log(airlineCache);

			//const source = $('#yvr-airline-info-template').html();
			//const template = Handlebars.compile(source);

			let template = null;

			if (document.documentElement.lang === "fr") {
				template = YVR.templates.airlineInfoFR;
			} else {
				template = YVR.templates.airlineInfoEN;
			}

			const html = template({ airlines: data.value });
			$('.display-airline-info').html(html);

		}
	}

	//bind click events for accordions
	function eventBindAccordion() {
		//console.log('event binding accordion');
		const accordionItems = document.querySelectorAll('.accordion');

		let firstAcc = accordionItems.item(0);
		let fheader = firstAcc.querySelector('.header');
		let fcontent = firstAcc.querySelector('.content');
		fheader.classList.toggle('active');
		fcontent.classList.toggle('active');

		accordionItems.forEach(item => {
			const header = item.querySelector('.header');
			const content = item.querySelector('.content');

			if (item.classList.contains('lounge')) {
				header.classList.toggle('active');
				content.classList.toggle('active');
			}

			header.addEventListener('click', () => {
				header.classList.toggle('active');
				content.classList.toggle('active');
			});
		});
	}

	// function to bind tns to carousels
	function eventBindSliders(security) {
		//console.log("event binding sliders");


		let bindClass = '.tns-bind-' + security;

		const tnsCarousel = document.querySelectorAll(bindClass);
		tnsCarousel.forEach(slider => {
			const tnsslider = tns({
				container: slider,
				loop: false,
				items: 1,
				slideBy: 1,
				edgepadding: 50,
				fixedWidth: 260,
				nav: false,
				autoplay: false,
				speed: 400,
				autoplayButtonOutput: false,
				mouseDrag: true,
				lazyload: false,
				responsive: {
					640: {
						items: 2,
						edgepadding: 0,
						fixedWidth: false
					},

					768: {
						items: 3
					}
				}

			});
		});
	}

	//function to bind shop dine services tabs for carousels
	function eventBindSliderTabs() {

		$('.tabs .tabsNav a').click(function (e) {
			let $tabs = $(this).closest('.tabs');
			$tabs.find('.tabsNav a.current').removeClass('current');
			$(this).addClass('current');

			$tabs.find('div.linkTab:not(:hidden)').hide();
			$(this.hash).show();

			e.preventDefault();
		});
	}

	//returns type of terminal
	function formatTerminal(aString) {
		if (aString === 'I') {
			return 'International';
		} else if (aString === 'D') {
			return 'Domestic';
		} else if (aString === 'T') {
			return 'US';
		} else if (aString === 'S') {
			return 'South';
		} else {
			return '';
		}
	}

	//gets shop dine data
	function getShopDineData() {

		//console.log('get shop dine data');

		if (flightCache && flightCache[0]) {


			let flightType = flightCache[0]['FlightType'];

			let terminal = flightCache[0]['FlightRange'];
			let terminalFormatted = formatTerminal(terminal);

			if (flightType === 'A') {
				//get facilities
				//getFacilities('All', filter);
				//render facilities
				getFacilities('Before', terminalFormatted)
					.then(transformFacilityData.bind(null, terminalFormatted, 'Before'));

			} else if (flightType === 'D') {
				//get before facilities
				getFacilities('Before', terminalFormatted)
					.then(transformFacilityData.bind(null, terminalFormatted, 'Before'));

				getFacilities('After', terminalFormatted)
					.then(transformFacilityData.bind(null, terminalFormatted, 'After'));
			}

		}
	}

	//creates api call to get relevant facilities
	function getFacilities(security, terminalFormatted): JQueryPromise<any> {

		//console.log('get facilities ' + security);

		let filter = [];

		if (security === 'After') {
			if (terminalFormatted === 'South') {
				filter.push('PoiTerminal eq \'South Terminal\'');
			} else {
				filter.push('PoiTerminal eq \'' + terminalFormatted + '\'');
			}
		}

		if (security !== 'All') {
			filter.push('PoiAccessibility eq \'' + security + '\'');
		}
		const url = `${options.facilities.serviceUrl}?$filter=${filter.join(' and ')}&$select=${options.facilities.select.join(',')}`;

		//console.log(url);
		return $.ajax({
			url,
			type: 'GET',
			success(data) {
				//console.log('[facilities][getFacilities] Successfully retrieved the facility data.');
			}
		});
	}

	// gets featured items
	function getFeaturedItems(data, terminal, category, security) {

		let filteredData = data;

		let id = 'featured-' + terminal + '-' + category + '-' + security;

		//console.log('featured id: ' + id);

		let elem = document.getElementById(id);
		if (elem == null) {
			return data;
		}

		let data_ids = elem.getAttribute('data-ids');
		if (data_ids == null) {
			return data;
		}

		let ids = data_ids.split(',');
		let featured = [];
		for (let i = 0; i < ids.length; i++) {

			let featuredId = ids[i];
			let feat = $.grep(data, function (node) {
				return node.PoiID == featuredId;
			});

			if (feat.length > 0) {
				featured = featured.concat(feat);

				for (let j = 0; j < filteredData.length; j++) {
					if (filteredData[j].PoiID == featuredId) {
						filteredData.splice(j, 1);
					}
				}
			}
		}

		featured = featured.concat(filteredData);

		return featured;
	}

	//function that combines cards of the same location
	function consolidateCards(data) {

		let duplicates = [];

		let rebuilt = [];

		for (let i = 0; i < data.length; i++) {

			let item = data[i];

			let list = $.grep(data, function (node) {
				return node.FacilityId === item.FacilityId;
			});


			if (list.length > 1) {


				//create duplicates list
				let PoiIDs = [];
				for (const obj of list) {

					if (!duplicates.find(dup => dup.PoiID == obj.PoiID)) {
						duplicates.push(obj);

					}

					PoiIDs.push(obj.PoiID);

				}

				//combining item
				if (!rebuilt.find(reb => reb.FacilityId == item.FacilityId)) {


					let rebuiltItem = list.find(li => li.IsOpenNow == true);

					let orderNowItem = list.find(op => op.OrderNowID);

					if (rebuiltItem == null) {
						rebuiltItem = list[0];
					}
					rebuiltItem['MultiLocation'] = true;
					rebuiltItem['PoiIDs'] = PoiIDs.toString();
					if (orderNowItem) {
						rebuiltItem['OrderNowID'] = orderNowItem.OrderNowID;
					}
					rebuilt.push(rebuiltItem);
				}


			} else {
				rebuilt.push(item);
			}
		}
		// //console.log('duplicates');
		// //console.log(duplicates);
		// //console.log('rebuilt');
		// //console.log(rebuilt);

		return rebuilt;
	}


	//sorts data and splits into shop, dine, services
	function transformFacilityData(terminal, security, data) {
		//console.log('transform data');

		let list = data.value;

		list.sort((a, b) => a.PoiNameLocID.localeCompare(b.PoiNameLocID));
		//console.log(list);
		let dine = $.grep(list, function (node) {
			return node.PoiCategory === dineFilter;
		});
		dine = getFeaturedItems(dine, terminal, 'Dine', security);

		let shop = $.grep(list, function (node) {
			return node.PoiCategory === shopFilter;
		});
		shop = getFeaturedItems(shop, terminal, 'Shop', security);

		let services = $.grep(list, function (node) {
			return node.PoiCategory === serviceFilter;
		});
		services = getFeaturedItems(services, terminal, 'Services', security);

		//card consolidation
		dine = consolidateCards(dine);
		shop = consolidateCards(shop);
		services = consolidateCards(services);

		//console.log(dine);
		//console.log(shop);
		//console.log(services);

		renderData(dine, 'dine', security);
		renderData(shop, 'shop', security);
		renderData(services, 'services', security);

		eventBindSliders(security);	//binds TNS
	}

	//uses handlebars to display data
	function renderData(data, category, security) {

		let displayHtml = '#display-' + category + '-' + security;
		//console.log(displayHtml);

		if (data.length > 0) {

			//const source = $('#yvr-shopdinecards-template').html();
			//const template = Handlebars.compile(source);

			let template = null;

			if (document.documentElement.lang === "fr") {
				template = YVR.templates.shopDineCardsFR;
			} else {
				template = YVR.templates.shopDineCardsEN;
			}

			const html = template({ data: data });
			$(displayHtml).html(html);

		} else {	//no data found
			let selectID = '#select-' + category + '-' + security;
			$(selectID).hide();
		}
	}


	main();
}
